import { useEffect, useState } from "react";

export const useHasScrolled = (distance: number) => {
    const [hasScrolled, setHasScrolled] = useState(false);

    useEffect(() => {
        const scrollHandler = () => {
            setHasScrolled(globalThis.scrollY > distance);
        };
        scrollHandler();
        document.addEventListener("scroll", scrollHandler);

        return () => {
            document.removeEventListener("scroll", scrollHandler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: add missing dependencies
    }, []);

    return hasScrolled;
};
